// AUTH
export const SET_AUTH = `SET_AUTH`
export const UPDATE_AUTH = `UPDATE_AUTH`
